// --- copied from https://www.npmjs.com/package/fast-deep-equal
var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

//@ts-ignore
export function equal(a: any, b: any) {
    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
        var arrA = isArray(a)
            , arrB = isArray(b)
            , i
            , length
            , key;

        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for (i = length; i-- !== 0;)
                if (!equal(a[i], b[i])) return false;
            return true;
        }

        if (arrA != arrB) return false;

        var dateA = a instanceof Date
            , dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();

        var regexpA = a instanceof RegExp
            , regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();

        var keys = keyList(a);
        length = keys.length;

        if (length !== keyList(b).length)
            return false;

        for (i = length; i-- !== 0;)
            if (!hasProp.call(b, keys[i])) return false;

        for (i = length; i-- !== 0;) {
            key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }

        return true;
    }

    return a !== a && b !== b;
};

export class ConcurrentEntryGuard<T> {
    promise: Promise<T> | null = null;
    call = async (callback: () => Promise<T>) => {
        if (this.promise) return await this.promise;
        this.promise = callback();
        try {
            return await this.promise;
        } finally {
            this.promise = null;
        }
    };
}

export function formatCurrency(number: number, currency: string = "DKK", culture: string = "da-DK", digits = 2) {
    return new Intl.NumberFormat(culture, { style: "currency", currency, minimumFractionDigits: digits, maximumFractionDigits: digits }).format(number === 0 ? 0 : number);
}

export function jsonDateTimeWithoutTimezone(x: Date) {
    // it's not pretty
    var json = JSON.stringify(new Date(x.getFullYear(), x.getMonth(), x.getDate(), x.getHours(), x.getMinutes() - x.getTimezoneOffset()));
    return json.substring(1, json.length - 2);
}

export function jsonDateWithoutTimezone(x: Date) {
    let text = jsonDateTimeWithoutTimezone(x);
    return text.substring(0, text.indexOf("T"));
}

export const ONE_DAY_AS_MS = 24 * 60 * 60 * 1000; // milliseconds in one day

export function getNumberOfDays(start: Date, end: Date) {
    const date1 = new Date(start);
    const date2 = new Date(end);
    const diffInTime = date2.getTime() - date1.getTime();
    const diffInDays = Math.round(diffInTime / ONE_DAY_AS_MS);
    return diffInDays;
}


export function getTodayString() {
    var dtToday = new Date();
    var month: number | string = dtToday.getMonth() + 1;
    var day: number | string = dtToday.getDate();
    var year = dtToday.getFullYear();
    if (month < 10)
        month = '0' + month.toString();
    if (day < 10)
        day = '0' + day.toString();
    return year + '-' + month + '-' + day;

}